<template>
  <div>
    <div class="tag-badge-info">
      <span class="tag-badge-title-info pl-3">{{ title }}</span>
    </div>
    <div class="dropdown-divider mt-0 pb-2 ml-3 w-100" />
  </div>
</template>

<script>
export default {
  name: 'SectionTitle',
  meta: {
    description: 'Componente para agregar títulos por secciones.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  data: function() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: '',
      meta: {
        description: 'Título del SectionTitle',
        example: 'Texto Necesario',
      },
    },
  },
};
</script>

<style scoped>
.tag-badge-info {
  display: inline-block;
  padding-right: 1em;
  height: auto;
  background: transparent -webkit-gradient(
      linear,
      left top,
      right top,
      from(#d9e5df),
      to(#ffffff)
    ) 0% 0% no-repeat padding-box;
  background: transparent linear-gradient(90deg, #d9e5df 0%, #ffffff 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
}
.tag-badge-title-info {
  font: Bold 15px Lato;
  color: #11291b;
}
</style>
